import { MasterFleetManagerEdit } from "./MasterFleetManagerEdit";
import SupervisorAccountOutlinedIcon from "@material-ui/icons/SupervisorAccountOutlined";
import { MasterFleetManagerCreate } from "./MasterFleetManagerCreate";
import { MasterFleetManagersList } from "./MasterFleetManagersList";

export default {
  icon: SupervisorAccountOutlinedIcon,
  list: MasterFleetManagersList,
  create: MasterFleetManagerCreate,
  edit: MasterFleetManagerEdit,
};
